<template>
	<div class="bg-top">

		<div class="font-weight-bold  justify-space-between items-center under-line pa-10">
			<div class="justify-start gap-10 size-px-24">
				<button
					@click="onSide"
				><v-icon>mdi mdi-menu</v-icon></button>
				<button
					@click="toMain"
				>
					<img
						v-if="false"
						:src="require('../../assets/images/logo.png')" :title="title" class="object-cover"
					/>
					{{ title }}
				</button>
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		name: 'Top'
		, components: {}
		, props: ['user', 'shop_info']
		, data: function(){
			return {
				search_value: ''
				, title: process.env.VUE_APP_TITLE
			}
		}
		, computed: {

		}
		,methods: {
			onSide: function(){
				this.$emit('toggleSide')
			}
			,toMain: function(){
				this.$bus.$emit('to', {name: 'Index', not_query: false})
			}
			, toPoint: function(){
				this.$bus.$emit('to', {name: 'PointItem', not_query: false})
			}
			, toList: function(pdt_div){
				if(pdt_div){
					this.$bus.$emit('to', {name: 'ProductList', params: { pdt_div: pdt_div}})
				}else{
					this.$bus.$emit('to', {name: 'ProductList'})
				}
			}
			, toLogin: function(){
				this.$bus.$emit('to', { name: 'Login'})
			}
			, toJoin: function(){
				this.$bus.$emit('to', { name: 'Join'})
			}
			, toMypage: function(){
				this.$bus.$emit('to', { name: 'MyPage'})
			}
			, toBoard: function(b_code){
				this.$bus.$emit('to', { name: 'CustomerCenter', params: { b_code: b_code }})
			}
			, toShopping: function(){
				this.$bus.$emit('to', { name: 'OrderList', params: { type: 'all'}})
			}
			, toCart: function(){
				this.$bus.$emit('to', { name: 'Cart', params: { pdt_div: 'business'}})
			}
			, toLogout: function(){
				if(confirm("로그아웃 하시겠습니까?")){
					this.$bus.$emit('logout')
				}
			}
		}
		,created() {
		}

		, watch: {
			$route(){
				this.search_value = ''
			}
		}
	}
</script>

<style>

</style>